require('./model.js');

PegasusTemplate.Template = PegasusTemplate.Model.extend({

});

PegasusTemplate.Template.FIXTURES = [];
